var dd = require('react-dd');
var _ = require('lodash');
var FormInputMixin = require('../FormInputMixin');

var placeholder_value = '__some$random$uuid__';

module.exports = {
	component: dd.createClass({
		mixins: [FormInputMixin],
		__onChange: function(e){
			var new_value = e.target.value;
			this._input_newValue(this.__isOption(new_value) ? new_value : null);
		},
		__onTextChange: function(e){
			this._input_newValue(e.target.value);
		},
		__getStateList: function(){
			var field = this.props.field;
			var Displaylists = field.Displaylists;
			var country = field.country;

			var u_lists = (Displaylists && Displaylists.universal) || {};
			return _.filter(u_lists.statelist, function(state){
				return state.sc == country;
			});//It should come pre-sorted from the server
		},
		__isOption: function(value){
			var countrylist = this.__getStateList();
			return _.includes(_.map(countrylist, 'ss'), value);
		},
		render: function(){
			var field = this.props.field;
			var value = this.props.value;
			var states = this.__getStateList();

			if(field.read_only){
				return dd.p({className: 'form-control-static'},
					this.__isOption(value) ? _.find(states,function(state){
						return state.ss === value;
					}).ls : value
				);
			}

			if(_.isEmpty(states)){
				return dd.input({
					type: 'text',
					placeholder: field.placeholder || 'State/Prov',
					className: 'form-control',
					value: value || '',
					name: this.props.field_path,
					onChange: this.__onTextChange
				});
			}

			value = this.__isOption(value) ? value : placeholder_value;

			return dd.select({
					className: 'form-control' + (field.disabled ? ' disabled' : ''),
					value: value,
					name: this.props.field_path,
					onChange: this.__onChange,
					disabled: field.disabled ? 'disabled' : null
				},
				dd.option({value: placeholder_value}, field.placeholder || '-- select state/province --'),
				_.map(states, function(state, i){
					return dd.option({key: i, value: state.ss}, state.ls);
				})
			);
		}
	}),
	validate: function(value){
		return !!value || 'Please select a state/province';
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/esState.js
// module id = 206
// module chunks = 0 1 2 3 4